/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * 굵게 마크 툴을 정의한다.
 *
 * @file /src/rootin/tools/bold/Bold.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2026. 7. 17.
 */
import { Tool } from '@rootin/base/Tool';
import { Block } from '@rootin/base/Block';
import { Element } from '@rootin/base/Element';
import { Language, LanguageText } from '@utils/Language';

export class Bold extends Tool {
    /**
     * 툴타입
     */
    static type: string = 'bold';

    /**
     * 툴그룹
     */
    static group: string = 'mark';

    /**
     * 툴아이콘
     */
    icon: string =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-bold-icon lucide-bold"><path d="M6 12h9a4 4 0 0 1 0 8H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7a4 4 0 0 1 0 8"/></svg>';

    /**
     * 툴팁
     */
    text: LanguageText = Language.get('rootin.tools.bold');

    /**
     * 적용/해제할 태그와 판정 셀렉터.
     */
    #tag = 'b';
    #selector = 'b, strong';

    /**
     * 툴 클릭시 실행할 핸들러를 정의한다.
     */
    handler(): void {
        this.editor.mark.toggle(this.#tag, this.#selector);
    }

    /**
     * 툴의 표시여부 조건을 설정한다.
     * @todo 커서가 편집 가능한 유닛 안이거나 다중 유닛이 선택돼 있을 때만 노출할지 고민한다.
     *
     * @param block - 커서가 위치한 블록
     * @param element - 커서가 위치한 편집유닛
     * @returns 표시여부
     */
    visible(block: Block | null, element: Element | null): boolean {
        return true;
        // return this.editor.mark.isVisible(element);
    }

    /**
     * 툴이 활성여부 조건을 설정한다.
     *
     * @returns 활성여부
     */
    active(): boolean {
        return this.editor.mark.isActive(this.#selector);
    }
}
